import { Component, OnInit } from '@angular/core';
import AdsCampaignStatuses from 'src/app/constants/ads-campaign-statuses';
import AdsCampaignTypes from 'src/app/constants/ads-campaign-types';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Organization } from 'src/app/classes/organization';
import { AdsCampaignService } from 'src/app/services/ads-campaign.service';

@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.css']
})

export class CampaignsComponent implements OnInit {
  adsCampaignStatuses = AdsCampaignStatuses;
  adsCampaignTypes = AdsCampaignTypes;

  organizations: Organization[] = [];

  form = new FormGroup({
    organization: new FormControl('all'),
    status: new FormControl('all'),
    type: new FormControl('all'),
    text: new FormControl(''),
  });
  
  constructor(
    private router: Router,
    private adsCampaignService: AdsCampaignService
  ) {}

  ngOnInit(): void {
    this.adsCampaignService.organizations().subscribe(organizations => {
      this.organizations = organizations;
    });
  }

  search() {
    this.router.navigate(['campaigns', 'search'], { queryParams: this.form.value });
  }
}
